import { GetStaticProps } from 'next'
import { useBreakpoints } from 'react-breakpoints-hook'
import Head from 'next/head'

import { Layout } from '@components/layout'
import { SectionWhatIsFreeEnergyMarket } from '@components/pages/mercado-livre-de-energia/section-what-is-free-energy-market'

import { Menu, MenusApi } from '@services/api/menus'
import SEO from '@components/shared/seo'
import { FixedBar } from '@components/v2/fixed-bar'
import { SectionFreeMarketWithSecurity } from '@components/pages/mercado-livre-de-energia/section-free-market-with-security'
import { SectionFreeMarketAdvantages } from '@components/pages/mercado-livre-de-energia/section-free-market-advantages'
import { SectionFormBanner } from '@components/pages/mercado-livre-de-energia/section-form-banner'
import { SectionQuestionsAboutFreeMarket } from '@components/pages/mercado-livre-de-energia/section-questions-about-free-market'
import { schemaData } from '@utils/schema-FAQ-page/mercado-livre-de-energia'

interface FreeEnergyMarketProps {
  main: Array<Menu>
  footer1: Array<Menu>
  footer2: Array<Menu>
}

const FreeEnergyMarket = ({
  main,
  footer1,
  footer2
}: FreeEnergyMarketProps) => {
  const { sm } = useBreakpoints({
    sm: { min: 1, max: 799 },
    md: { min: 800, max: null }
  })

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Head>

      <Layout
        mainMenus={main}
        footerMenus1={footer1}
        footerMenus2={footer2}
        fullContent
      >
        <SEO
          title="Mercado Livre de Energia: conheça e migre!"
          description="Mude para o Mercado Livre de Energia e economize na conta de luz! Saia do mercado cativo e compre energia elétrica direto de uma usina solar! Saiba mais!"
          canonicalUrl={`${
            process.env.NEXT_PUBLIC_URL_BASE || 'https://www.portalsolar.com.br'
          }/mercado-livre-de-energia`}
        />

        <FixedBar
          showFixedBarFrom={300}
          onClick={scrollToTop}
          whatsapp={{
            number: '+5511972132657',
            text: 'Olá, estou interessado em saber mais informações sobre o Mercado Livre de Energia.'
          }}
          btnTitle={sm ? 'Comece Agora' : 'Faça parte do Mercado Livre'}
        />

        <section>
          <SectionFormBanner />
        </section>

        <section>
          <SectionWhatIsFreeEnergyMarket smoothScroll={scrollToTop} />
        </section>

        <section>
          <SectionFreeMarketWithSecurity smoothScroll={scrollToTop} />
        </section>

        <section>
          <SectionFreeMarketAdvantages smoothScroll={scrollToTop} />
        </section>

        <section>
          <SectionQuestionsAboutFreeMarket />
        </section>
      </Layout>
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  try {
    const menus = await MenusApi.all()

    return {
      props: {
        ...menus
      },
      revalidate: 60 * 1
    }
  } catch (error) {
    return {
      notFound: true,
      revalidate: 1
    }
  }
}

export default FreeEnergyMarket
